/**
 * Normalizuje nazwę projektu do bezpiecznego formatu dla URL i systemu plików
 */
export const normalizeProjectName = (name: string): string => {
  return name
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // usuń znaki diakrytyczne
    .replace(/[^a-z0-9-]/g, '-') // zamień niedozwolone znaki na myślnik
    .replace(/-+/g, '-') // zamień wielokrotne myślniki na pojedynczy
    .replace(/^-|-$/g, '') // usuń myślniki z początku i końca
}

/**
 * Formatuje ścieżkę do pliku, zapewniając odpowiedni format
 */
export const formatImagePath = (path: string): string => {
  // Usuń przedrostek /var/www/html jeśli istnieje
  let formattedPath = path.replace('/var/www/html/', '')
  
  // Dodaj / na początku ścieżki, jeśli nie istnieje
  if (!formattedPath.startsWith('/')) {
    formattedPath = '/' + formattedPath
  }
  
  return formattedPath
}

/**
 * Pobiera rozszerzenie pliku z jego nazwy
 */
export const getFileExtension = (filename: string): string => {
  return filename.split('.').pop()?.toLowerCase() || ''
}

/**
 * Sprawdza, czy plik ma dozwolone rozszerzenie
 */
export const hasAllowedExtension = (
  filename: string, 
  allowedExtensions: string[] = ['jpg', 'jpeg', 'png', 'gif', 'avif', 'webp']
): boolean => {
  const extension = getFileExtension(filename)
  return allowedExtensions.includes(extension)
}

/**
 * Formatuje rozmiar pliku w czytelny sposób (np. KB, MB)
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B'
  
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}